<template>
  <div class="energy-consumption-statistics d-flex flex-column">
    <div
      class="select-container d-flex align-items-center section-container"
      :class="{ dark: skinType }"
    >
      <SectionTitle title="能耗统计"></SectionTitle>
      <project-level-selector
        @selectItem="selectItemListener"
        levelType="pds"
        style="margin-right: 1rem"
      ></project-level-selector>
      <span class="tongjifangshi">统计方式:</span>
      <el-select v-model="periodType" size="small" class="xlk">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="selectPeriod"
        size="small"
        :type="periodType == 'Day' ? 'daterange' : 'monthrange'"
        :format="periodType === 'Day' ? 'yyyy-MM-dd' : 'yyyy-MM'"
        :value-format="periodType === 'Day' ? 'yyyy-MM-dd' : 'yyyy-MM'"
        range-separator="至"
      >
      </el-date-picker>
      <el-button
        type="primary"
        size="small"
        style="margin-left: 1rem"
        @click="onSubmit"
        >查询</el-button
      >
    </div>
    <div class="d-flex flex-column none-height flex-grow-1">
      <el-row
        class="part-container align-items-stretch none-height flex-grow-1"
        type="flex"
        :gutter="12"
      >
        <!-- <el-col :span="8" class="d-flex">
          <SectionContainer title="供电概况" class="flex-grow-1 d-flex">
            <template v-slot:header>
              <div :style="{color: skinType?'#ccc':'#aaa'}" style="font-size:1rem;">
                {{selectPeriod[0]}}至{{selectPeriod[1]}} </div>
            </template>
            <el-row class="flex-grow-1" type="flex" v-if="briefInfo">
              <el-col
                :span="8"
                class="general-situation d-flex flex-column
                 justify-content-center align-items-center"
              >
                <img :src="img1" class="section-image" />
                <span style="margin-top: 0.5rem">总供电量</span>
                <span
                  ><span
                    style="
                      color: #FFAF8E;
                      font-size: 1.2rem;
                      margin-top: 0.5rem;
                    "
                    @click="FunClickNum"
                    >{{ briefInfo.GongDianLiang }}</span
                  ><span class="">kWh</span></span
                >
              </el-col>
              <el-col
                :span="8"
                class="general-situation d-flex flex-column
                 justify-content-center align-items-center"
              >
                <img :src="img2" class="section-image" />
                <span style="margin-top: 0.4rem">总用电量</span>
                <span
                  ><span
                    style="
                      color: #FFAF8E;
                      font-size: 1.2rem;
                      margin-top: 0.5rem;
                    "
                    @click="FunClickNum"
                    >{{ briefInfo.YongDianLiang }}</span
                  ><span class="">kWh</span></span
                >
              </el-col>
              <el-col
                :span="8"
                class="general-situation d-flex flex-column
                 justify-content-center align-items-center"
              >
                <img :src="img3" class="section-image" />
                <span style="margin-top: 0.4rem">损失电量(占比)</span>
                <span
                  ><span
                    style="
                      color: #FFAF8E;
                      font-size: 1.2rem;
                      margin-top: 0.5rem;
                    "
                    @click="FunClickNum"
                    >{{ briefInfo.SunShiDianLiang }}</span
                  ><span class="">kWh({{ briefInfo.ZhanBi }}%)</span></span
                >
              </el-col>
            </el-row>
            <no-data-temporarily
              v-else
              style="width: 100%; height: 100%"
            ></no-data-temporarily>
          </SectionContainer>
        </el-col> -->
        <el-col :span="12" class="d-flex">
          <SectionContainer
            title="电能消耗分析-分区对比"
            class="flex-grow-1 d-flex"
          >
            <fenquduibi
              :proId="proId"
              :selectPeriod="selectPeriod"
              :periodType="periodType"
              @FunShowSankey="FunShowSankey"
            />
          </SectionContainer>
        </el-col>
        <el-col :span="12" class="d-flex">
          <SectionContainer
            title="电能消耗分析-分项对比"
            class="flex-grow-1 d-flex"
          >
            <fenxiangbi
              :proId="proId"
              :selectPeriod="selectPeriod"
              :periodType="periodType"
              @FunShowSankey="FunShowSankey"
            />
          </SectionContainer>
        </el-col>
      </el-row>
      <el-row
        class="part-container d-flex align-items-stretch none-height flex-grow-2"
        :gutter="12"
      >
        <!-- <el-col :span="8" class="d-flex">
          <SectionContainer
            title="供电对比分析"
            class="flex-grow-1 d-flex flex-column d-flex flex-column"
          >
            <div class="d-flex flex-column flex-grow-1" style="padding: 0.6rem">
              <gnfxdb
                class="none-height flex-grow-1"
                :proId="proId"
                :selectPeriod="selectPeriod"
                :periodType="periodType"
              />
              <nhtjeryoushuju
                class="none-height flex-grow-1"
                style="margin-top: 0.6rem"
                :proId="proId"
                :selectPeriod="selectPeriod"
                :periodType="periodType"
              />
            </div>
          </SectionContainer>
        </el-col> -->
        <el-col :span="24" class="d-flex flex-column">
          <SectionContainer
            title="电能消耗对比分析-分区对比"
            class="none-height flex-grow-1 d-flex"
          >
            <div
              class="d-flex flex-column flex-grow-1"
              style="position: relative;"
            >
              <el-radio-group v-model="radioList2" size="mini" style="position: absolute;top: -40px;left: calc(50% - 56px)">
                <el-radio-button label="1">图形</el-radio-button>
                <el-radio-button label="2">数据</el-radio-button>
              </el-radio-group>
              <div
                class="none-height flex-grow-1 d-flex section-container"
                style="padding: 0 0.6rem 0.6rem"
                :class="{ dark: skinType }"
              >
                <duibifenqubi
                  v-if="this.radioList2 == 1"
                  class="none-width flex-grow-1 d-flex"
                  :proId="proId"
                  :selectPeriod="selectPeriod"
                  :periodType="periodType"
                  @FunShowSankey="FunShowSankey"
                />
                <duibifenxibiao
                  v-else
                  class="none-width flex-grow-1"
                  :proId="proId"
                  :selectPeriod="selectPeriod"
                  :periodType="periodType"
                />
              </div>
            </div>
          </SectionContainer>
          <div style="height: 1rem"></div>
          <SectionContainer
            title="电能消耗对比分析-分项对比"
            class="none-height flex-grow-1 d-flex flex-column"
          >
            <div
              class="none-height d-flex flex-column flex-grow-1"
              style="position: relative;"
            >
              <el-radio-group v-model="radioList4" size="mini" style="position: absolute;top: -40px;left:calc(50% - 56px)">
                <el-radio-button label="1">图形</el-radio-button>
                <el-radio-button label="2">数据</el-radio-button>
              </el-radio-group>
              <div
                class="none-height flex-grow-1 section-container flex-grow-1 d-flex"
                style="padding: 0 0.6rem 0.6rem"
                :class="{ dark: skinType }"
              >
                <duibifenxiangbi
                  v-if="this.radioList4 == 1"
                  class="none-width flex-grow-1"
                  :proId="proId"
                  :selectPeriod="selectPeriod"
                  :periodType="periodType"
                  @FunShowSankey="FunShowSankey"
                />
                <duibifenxiangbiao
                  v-else
                  class="none-width flex-grow-1"
                  :proId="proId"
                  :selectPeriod="selectPeriod"
                  :periodType="periodType"
                />
              </div>
            </div>
          </SectionContainer>
        </el-col>
      </el-row>
    </div>
    <el-dialog
    title=""
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose">
      <div id="nengliutuIndex"   style="width: 100%; height: 600px"></div>
  </el-dialog>
  </div>
</template>
<script>
import ProjectLevelSelector from '@/components/utils/project-level-selector.vue';
import {
  GetGongNengGaiKuangAndBarChart,
  GetDianNengXaoHaoForPieChart,
  GetGetSankeyDataSource,
} from '@/api/enery-analysis/eneryanalysis';
import { formatDate } from '@/utils/utils';
import SectionTitle from '@/components/utils/section-title.vue';
import SectionContainer from '@/components/utils/section-container.vue';
import warningColorPng from '@/assets/images/yyimg/warning-color.png';
import visualizeColorPng from '@/assets/images/yyimg/visualize-color.png';
import amountColorPng from '@/assets/images/yyimg/amount-color.png';
import fenxiangbi from '../../platform/ym/fenxiangbi.vue';
import duibifenqubi from '../../platform/ym/duibifenqubi.vue';
import duibifenxibiao from '../../platform/ym/duibifenxibiao.vue';
import duibifenxiangbi from '../../platform/ym/duibifenxiangbi.vue';
import duibifenxiangbiao from '../../platform/ym/duibifenxiangbiao.vue';
import fenquduibi from '../../platform/ym/fenquduibi.vue';

export default {
  data() {
    return {
      selectNode: null,
      seriesData: [],
      xAxisData: [],
      proId: '',
      daterange: '',
      img1: warningColorPng,
      img2: visualizeColorPng,
      img3: amountColorPng,
      options: [
        {
          value: 'Day',
          label: '日',
        },
        {
          value: 'Month',
          label: '月',
        },
      ],
      periodType: 'Day',
      selectPeriod: [
        formatDate(new Date(), 'yyyy-MM-01'),
        formatDate(new Date(), 'yyyy-MM-dd'),
      ],
      radioList1: 1,
      radioList2: 1,
      radioList4: 1,
      briefInfo: null,
      dialogVisible: false,
      myChartsankey: null,
    };
  },
  components: {
    fenxiangbi,
    duibifenqubi,
    duibifenxibiao,
    duibifenxiangbi,
    duibifenxiangbiao,
    fenquduibi,
    ProjectLevelSelector,
    SectionTitle,
    SectionContainer,
  },
  watch: {
    periodType() {
      this.selectPeriod = this.getInitialPeriod();
    },
    selectPeriod() {
      this.requestDataList();
    },
    selectNode() {
      this.requestDataList();
    },
  },
  created() {
    this.requestDataList();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    onSubmit() {
      this.requestDataList();
    },
    requestDataList() {
      if (this.selectNode === null) {
        return;
      }
      this.requestPowerProfile();
      this.requestPowerConsumption();
    },
    requestPowerProfile() {
      const [start, end] = this.selectPeriod;
      GetGongNengGaiKuangAndBarChart({
        StationIdStr: this.selectNode.IdStr,
        DateType: this.periodType,
        BeginDate: start,
        EndDate: end,
      })
        .then((res) => {
          this.briefInfo = res.GongNengGaiKuang;
        })
        .catch(() => {
          this.briefInfo = null;
        });
    },
    requestPowerConsumption() {
      const [start, end] = this.selectPeriod;
      GetDianNengXaoHaoForPieChart({
        StationIdStr: this.selectNode.IdStr,
        DateType: this.periodType,
        BeginDate: start,
        EndDate: end,
      })
        .then((res) => {
          this.FenXiangData = res.FenXiangData;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getInitialPeriod() {
      let formatStr;
      switch (this.periodType) {
        case 'Day':
          formatStr = ['yyyy-MM-01', 'yyyy-MM-dd'];
          break;
        case 'Month':
          formatStr = ['yyyy-01', 'yyyy-MM'];
          break;
        default:
          formatStr = [];
          break;
      }
      console.log('formatStr', formatStr);
      return formatStr.map((format) => formatDate(new Date(), format));
    },
    selectItemListener(selectNode) {
      if (selectNode.oType === 'pds') {
        this.selectNode = selectNode;
        this.proId = selectNode.IdStr;
      }
    },
    FunClickNum() {
      const [start, end] = this.selectPeriod;
      this.FunShowSankey({
        StationIdStr: this.proId,
        DateType: this.periodType,
        BeginDate: start,
        EndDate: end,
        FenQvName: '',
        FenXiangName: '',
        IsMix: false,
      });
    },
    FunShowSankey(data) {
      this.dialogVisible = true;
      GetGetSankeyDataSource(data)
        .then((res) => {
          this.IniNengLiuTu(res, data.color);
        })
        .catch(() => {
          // this.FenXiangData = null;
        });
    },
    handleClose(done) {
      console.log(done);
      done();
    },
    IniNengLiuTu(data, color) {
      let { myChartsankey } = this;
      if (myChartsankey != null && myChartsankey !== '' && myChartsankey !== undefined) {
        myChartsankey.dispose();
      }
      myChartsankey = this.$echarts.init(document.getElementById('nengliutuIndex'));
      myChartsankey.setOption(
        ({
          title: {
            text: '能流图',
          },
          // tooltip: {
          //   trigger: 'item',
          //   triggerOn: 'mousemove',
          // },
          series: [
            {
              type: 'sankey',
              data: data.nodes,
              links: data.links,
              emphasis: {
                focus: 'adjacency',
              },
              levels: [
                {
                  depth: 0,
                  itemStyle: {
                    color,
                  },
                  lineStyle: {
                    color: 'source',
                    opacity: 0.6,
                  },
                },
                {
                  depth: 1,
                  itemStyle: {
                    color: '#b3cde3',
                  },
                  lineStyle: {
                    color: 'source',
                    opacity: 0.6,
                  },
                },
                {
                  depth: 2,
                  itemStyle: {
                    color: '#ccebc5',
                  },
                  lineStyle: {
                    color: 'source',
                    opacity: 0.6,
                  },
                },
                {
                  depth: 3,
                  itemStyle: {
                    color: '#decbe4',
                  },
                  lineStyle: {
                    color: 'source',
                    opacity: 0.6,
                  },
                },
              ],
              lineStyle: {
                curveness: 0.5,
              },
            },
          ],
          label: {
            formatter(obj) {
              let strName = obj.name;
              let arrName = new Array(2);
              arrName = strName.split('|');
              // debugger;
              if (arrName.length > 0) {
                const [name] = arrName;
                strName = name;
              }
              return strName;
            },
          },
          tooltip: {
            formatter(obj) {
              let strReturn = '';
              if (obj.data) {
                if (obj.data.name) {
                  let strName = obj.name;
                  let arrName = new Array(2);
                  arrName = strName.split('|');
                  // debugger;
                  if (arrName.length > 0) {
                    const [name] = arrName;
                    strName = name;
                  }
                  const dValue = obj.value;
                  strReturn = `<span style="font-size:14px;color:#666;font-weight:400;">${strName}</span><span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900"><span style='color:red'>${dValue}</span> kWh</span>`;
                } else if (obj.data.source && obj.data.target && obj.data.value) {
                  let strSource = obj.data.source;
                  let arrSource = new Array(2);
                  arrSource = strSource.split('|');
                  // debugger;
                  if (arrSource.length > 0) {
                    const [name] = arrSource;
                    strSource = name;
                  }
                  let strTarget = obj.data.target;
                  let arrTarget = new Array(2);
                  arrTarget = strTarget.split('|');
                  // debugger;
                  if (arrTarget.length > 0) {
                    const [name] = arrTarget;
                    strTarget = name;
                  }
                  const dValue = obj.data.value;
                  strReturn = `<span style="font-size:14px;color:#666;font-weight:400;">${strSource} -- ${strTarget}</span><span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900"><span style='color:red'>${dValue}</span> kWh</span>`;
                }
              }
              return strReturn;
            },
          },
        }),
      );
    },
  },
};
</script>

<style lang="less" scoped>
.general-situation {
  position: relative;
}
.general-situation + .general-situation:before {
  position: absolute;
  content: " ";
  width: 6px;
  height: 60px;
  left: 0;
  background-image: url(../../../assets/images/yyimg/line.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
/deep/.el-date-editor--daterange.el-input,
/deep/.el-date-editor--daterange.el-input__inner,
/deep/.el-date-editor--timerange.el-input,
/deep/.el-date-editor--timerange.el-input__inner {
  width: 260px;
}
.flex-grow-2 {
  flex-grow: 2;
}
.xlk {
  width: 5rem;
  margin-right: 1rem;
}
.part-container + .part-container {
  margin-top: 1rem;
}
.tubiaozuo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.tubiaoyou {
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.select-container {
  padding: 1rem;
  margin-bottom: 1rem;
}
.tongjifangshi {
  height: 80%;
  font-size: 1.2rem;
  margin-left: 1rem;
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
}
.section-image {
  height: 2.6rem;
}
.overflow-y {
  overflow-y: auto;
  overflow-x: hidden;
}
.el-dialog__body {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  background-color: #223388;
}
</style>
